import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StepComponentProps } from "@/components/organisms";
import { StyledHeaderTitleBase } from "@/styles/components";

import EmailsGroup from "./components/EmailGroup/EmailsGroup";
import PhonesGroup from "./components/PhonesGroup/PhonesGroup";

const ContactStep: FC<StepComponentProps> = () => {
    const { t } = useTranslation();

    return (
        <>
            <StyledHeaderTitleBase>{t("Common.Contact")}</StyledHeaderTitleBase>
            <PhonesGroup />
            <EmailsGroup />
        </>
    );
};

export default ContactStep;
